import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import useRequest from '@swf/core/hooks/useRequest';
import type { Dispatch } from '@swf/core/store';
import { PokerModalRoutes } from '@swf/core/types/Poker';
import type {
  CreateClubRequest,
  CreateClubResponse,
  HGCreateClubReply
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse } from '@swf/poker';

import type { FormValues } from '../CreateClub';

interface State {
  error?: string | null;
  message?: string | null;
  data: HGCreateClubReply;
}

interface CreateResponse {
  body: CreateClubResponse;
}

const initialResponse: State = { error: null, message: null, data: {} };

const useCreateClub = () => {
  const [response, setResponse] = useState(initialResponse);
  const [loading, setLoading] = useState(false);
  const request = useRequest();
  const { modal } = useDispatch<Dispatch>();
  const {
    state: { widgetId }
  } = useLocation<{ widgetId?: string }>();

  const handleSubmit = ({ clubName, invitationCode }: FormValues) => {
    setLoading(true);
    request({
      service: 'homeGames.createClubRequest',
      body: {
        createClub: {
          clubName,
          password: invitationCode
        } as CreateClubRequest
      }
    }).subscribe(({ body }: CreateResponse) => {
      const { error, data, message } = handleServerResponse<CreateClubResponse, HGCreateClubReply>({
        response: body,
        accessor: 'createClubReply'
      });

      setResponse({ error, data, message });
      setLoading(false);

      if (!error) {
        modal.replace([
          {
            path: PokerModalRoutes.createClubSuccess,
            locationState: { ...data, clubName, invitationCode, widgetId }
          }
        ]);
      }
    });
  };

  return { response, loading, handleSubmit };
};

export default useCreateClub;
